// Auto-generated index file for locale exports
import en from './en'
import fr from './fr'

const locales = {
  en: en,
  fr: fr
}

export default locales
